// src/features/admin/components/NotificationFilters.tsx
import React, { useEffect, useState } from "react";

interface Props {
  initialStatus: string[];
  query: string;
  onChange: (statuses: string[], query: string) => void;
}

const ALL: { code: string; label: string }[] = [
  { code: "queued", label: "Queued" },
  { code: "sending", label: "Sending" },
  { code: "failed", label: "Failed" },
  { code: "sent", label: "Sent" },
  { code: "acknowledged", label: "Acknowledged" }
];

const NotificationFilters: React.FC<Props> = ({ initialStatus, query, onChange }) => {
  const [statuses, setStatuses] = useState<string[]>(initialStatus || []);
  const [q, setQ] = useState(query || "");

  useEffect(() => {
    setStatuses(initialStatus || []);
  }, [initialStatus]);

  useEffect(() => {
    setQ(query || "");
  }, [query]);

  const toggle = (code: string) => {
    setStatuses((prev) => {
      const next = prev.includes(code) ? prev.filter((c) => c !== code) : [...prev, code];
      onChange(next, q);
      return next;
    });
  };

  return (
    <section className="space-y-4">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex flex-wrap gap-3">
          {ALL.map((s) => (
            <label
              key={s.code}
              className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-3 py-2"
            >
              <input
                type="checkbox"
                checked={statuses.includes(s.code)}
                onChange={() => toggle(s.code)}
              />
              <span className="font-body text-sm text-slate-800">{s.label}</span>
            </label>
          ))}
        </div>

        <input
          className="w-full sm:w-72 border border-slate-200 rounded-full px-4 py-2 font-body text-sm"
          placeholder="Search payload, clinic, email…"
          value={q}
          onChange={(e) => {
            const nextQ = e.target.value;
            setQ(nextQ);
            onChange(statuses, nextQ);
          }}
        />
      </div>

      <div className="font-ui text-xs uppercase tracking-wide text-slate-500">
        Tip: Uncheck statuses to hide them.
      </div>
    </section>
  );
};

export default NotificationFilters;
